import { useUser } from '@/store/user'
import { useAuth } from '@/store/auth'
import { getBaseAuthHeader } from '@/libs/api/auth/login'

// Adds the correct Authorization header after any active token refresh is done.
export function addAuthorizationHeader(config) {
  const auth = useAuth()
  const user = useUser()

  if (config.skipAuth) {
    return config
  }

  config.headers = config.headers ?? {}

  if (config.withBasicAuth && auth.baseAuthEnoughData) {
    config.headers['Authorization'] = getBaseAuthHeader(
      auth.email,
      auth.password,
    )
  } else if (user.authorized && config.retryable) {
    config.headers['Authorization'] = `Bearer ${auth.accessToken}`
  }

  return config
}
